<template>
  <exec-report-panel report-name="delivery-ops" title="Operación y entregas" :filters="filters" @error="$emit('error', $event)" />
</template>

<script>
import ExecReportPanel from './ExecReportPanel.vue';
// Pestaña 9 · Operación y entregas (doc 04 §3, reporte 9).
export default { name: 'ExecDelivery', components: { ExecReportPanel }, props: { filters: { type: Object, default: () => ({}) } } };
</script>
